import { http } from "@/http/axios.js";
// 变更收货地址
export function updateOrderAddressAPI(data) {
  return http({
    url: "/admin/order/edit/address",
    method: "post",
    data,
  });
}
// 变更订单商品
export function updateOrderGoodsAPI(data) {
  return http({
    url: "/admin/order/edit/goods",
    method: "post",
    data,
  });
}
// 商品列表
export function getGoodsListAPI(params) {
  return http({
    url: "/admin/goods/page",
    method: "get",
    params,
  });
}
// 商品详情
export function getGoodsDetailAPI(id) {
  return http({
    url: "/admin/goods/detail",
    method: "get",
    params: { id },
  });
}
// 修改客服
export function allocateOrderKfAPI(data) {
  return http({
    url: "/admin/kf/order/allocate",
    method: "post",
    data,
  });
}
// 修改BD
export function updateOrderBDAPI(data) {
  return http({
    url: "/admin/order/storeBD/edit",
    method: "post",
    data,
  });
}
// 修改市场助理
export function updateOrderMaUserAPI(data) {
  return http({
    url: "/admin/order/maUser/edit",
    method: "post",
    data,
  });
}
// 备注列表
export function getRemarkListAPI(params) {
  return http({
    url: "/admin/order/trace/page",
    method: "get",
    params,
  });
}
// 添加备注
export function handleAddRemarkAPI(data) {
  return http({
    url: "/admin/order/trace/add",
    method: "post",
    data,
  });
}
// 用户评分
export function handleMemberGradeAPI(data) {
  return http({
    url: "/admin/member/grade",
    method: "post",
    data,
  });
}
// 紧急联系人列表
export function getRelationListAPI(memberId) {
  return http({
    url: "/admin/member/relation/list",
    method: "get",
    params: { memberId },
  });
}
// 校验紧急联系人
export function riskRelationAPI(data) {
  return http({
    url: "/admin/member/relation/risk/alert",
    method: "post",
    data,
  });
}
// 添加紧急联系人
export function addRelationAPI(data) {
  return http({
    url: "/admin/member/relation/add",
    method: "post",
    data,
  });
}
// 编辑紧急联系人
export function editRelationAPI(data) {
  return http({
    url: "/admin/member/relation/edit",
    method: "post",
    data,
  });
}
// 紧急联系人详情
export function getRelationDetailAPI(id) {
  return http({
    url: "/admin/member/relation/detail",
    method: "get",
    params: { id },
  });
}
// 删除紧急联系人
export function delRelationAPI(id) {
  return http({
    url: "/admin/member/relation/delete",
    method: "post",
    data: { id },
  });
}
// 保存工作单位
export function saveMemberProfileAPI(data) {
  return http({
    url: "/admin/member/profile/save",
    method: "post",
    data,
  });
}
// 是否监管
export function handleEnableAbmAPI(data) {
  return http({
    url: "/admin/order/edit/abm",
    method: "post",
    data,
  });
}
// 修改零售价
export function updatePriceAPI(data) {
  return http({
    url: "/admin/order/salePrice/edit",
    method: "post",
    data,
  });
}
// 物流详情
export function getDeliveryDetailAPI(orderNo) {
  return http({
    url: "/admin/order/delivery/trace",
    method: "get",
    params: { orderNo },
  });
}
// 门店待结算金额计算
export function calcStoreSettleAPI(data) {
  return http({
    url: "/admin/order/store/settle/calc",
    method: "post",
    data,
  });
}
//门店结算金额保存
export function calcStoreSaveApi(data) {
  return http({
    url: "/admin/order/store/settle/save",
    method: "post",
    data,
  });
}
//门店待结算金额明细
export function settlementAmountDetails(params) {
  return http({ url: "/admin/order/store/settle/info", method: "get", params });
}

// 评分明细列表
export function getScoreBillInfoAPI(params) {
  return http({
    url: "/admin/order/score/bill/list",
    method: "get",
    params,
  });
}

// 获取公证详情
export const getNotaryDetail = (params) => {
  return http({
    url: "/admin/order/notaryPhx/detail",
    method: "get",
    params,
  });
};

// 申请公证链接
export const applyNotary = (data) => {
  return http({
    url: "/admin/order/notaryPhx/apply",
    method: "post",
    data,
  });
};

// 初审通过
export const passNotary = (data) => {
  return http({
    url: "/admin/order/notaryPhx/pass",
    method: "post",
    data,
  });
};

// 修改&提交公证书审核
export const passNotaryAndModify = (data) => {
  return http({
    url: "/admin/order/notaryPhx/pass2",
    method: "post",
    data,
  });
};

// 取消并重新发起公证
export const retryNotary = (data) => {
  return http({
    url: "/admin/order/notaryPhx/retry",
    method: "post",
    data,
  });
};

// 取消公证
export const cancelNotary = (data) => {
  return http({
    url: "/admin/order/notaryPhx/cancel",
    method: "post",
    data,
  });
};

// 身份证OCR
export const idcaedOCR = (data) => {
  return http({
    url: "/admin/member/idCard/ocr",
    method: "post",
    data,
  });
};

// 修改设备串号
export function editDeviceSnAPI(data) {
  return http({
    url: "/admin/order/deviceSn/edit",
    method: "post",
    data,
  });
}

// 修改发货照片
export function editDeliveryAPI(data) {
  return http({
    url: "/admin/order/delivery/edit",
    method: "post",
    data,
  });
}

// 获取风控标签
export const getRiskTagTreeAPI = (params) => {
  return http({
    url: "/admin/riskTag/tree",
    method: "get",
    params,
  });
};

// 修改风控标签
export function editRiskTagAPI(data) {
  return http({
    url: "/admin/order/riskTag/edit",
    method: "post",
    data,
  });
}

/**
 * 获取获户链接
 */
export function getCustomerAcquisitionLinkAPI(data) {
  return http({
    url: "/admin/order/wxcp/customerAcquisitionLink/generate",
    method: "post",
    data,
  });
}
